export default {
  get: (filename, opts) => {
    if (!opts) opts = {}
    if (!filename) return ''
    var ext = (/[^./\\]*$/.exec(filename) || [''])[0]
    return opts.preserveCase ? ext : ext.toLowerCase()
  }
}
